__turbopack_context__.v({
  "community-cta": "community-cta-button-module-scss-module__7sA1yq__community-cta",
  "dark-cover": "community-cta-button-module-scss-module__7sA1yq__dark-cover",
});
